import {
  AuthServiceClient
} from "@/proto/auth_grpc_web_pb";
import { 
  LoginRequest,
  RefreshRequest
} from "@/proto/auth_pb";

export class AuthApi {
  client: AuthServiceClient;

  constructor() {
    const host:string = (window as any).VUE_APP_API_URL ?? '';
    this.client = new AuthServiceClient(host, null, null);
  }

  // Авторизация
  login(data: any){

    const request = new LoginRequest();
    request.setAuthCode(data.authCode);

    return new Promise((resolve, reject) => {
      this.client.login(request, {}, (err, message) => {
        if (err) {
          reject(err)
        } else {
          resolve(message);
        }
      });
    });
  }

  // Обновление токена
  refresh(data: any){

    const request = new RefreshRequest();
    request.setRefreshToken(data.refreshToken);

    return new Promise((resolve, reject) => {
      this.client.refresh(request, {}, (err, message) => {
        if (err) {
          reject(err)
        } else {
          resolve(message);
        }
      });
    });
  }
}